<div
    [class.chat-contact-window-page]="(isPage$ | async) === true"
    class="chat-contact-window chatbot url-chat"
    [class.open]="selectChatOpened$ | async"
>
    <div class="intro right-side h-100">
        <!-- Loader -->
        <loading *ngIf="loading$ | async"></loading>

        <!-- Cabecera -->
        <div class="chatbot-header is-flex" (click)="close()">
            <svg-icon class="is-invert pl-16 pr-16" src="chat"></svg-icon>
            <span>{{ 'dev.chatbot.onlineShoppingAssistant' | translate }}</span>
            <i class="chatbot-close-url" [hidden]="(isPage$ | async) === true">
                <svg-icon class="url-icon-close is-invert" src="close"></svg-icon>
            </i>
        </div>

        <!-- Iframe -->
        <div class="device-wrapper h-100">
            <div id="imbee" class="contenido h-100">
                <iframe *ngIf="urlChat$ | async as url" id="imbee-app-iframe" [src]="url" width="100%" height="100%" frameborder="0"></iframe>
            </div>
        </div>
    </div>
</div>
